// vue
import Vue from "vue";
import { mapGetters } from "vuex";

// services
import { ObjectUtil, ShoppingCartService } from "@/services";

// components
import { IGridListRowItem } from "@/components/Elements/PartsListGrid/PartsListGrid";
import { IShoppingCartContext } from "../../Types";
import { default as PartListing } from "../PartListing.vue";

// types

export default Vue.extend({
  name: "RemovePartsConfirmation",
  components: {
    PartListing,
  },
  props: {
    context: {
      type: Object,
      default: () => ObjectUtil.createInstance<IShoppingCartContext>(),
    },
    items: {
      type: Array,
      default: () => [] as IGridListRowItem[],
    },
  },
  computed: {
    ...mapGetters(["getContentItem"]),
  },
  methods: {
    async removeSelectedItems() {
      this.$emit("on-parts-removing");

      const items = this.items as IGridListRowItem[];
      const context = this.context as IShoppingCartContext;

      const rq = {
        accountId: context.accountId,
        userId: context.user.UserId,
        userAudiences: context.userAudiences,
        orderType: context.orderType,
        promoCodes: context.promoCodes,
        shoppingCartId: context.cartId,
        itemIds: items.filter((x) => x.Selected).map((x) => x.Id),
        currencyDecimalDigits: 2
      };

      const result = await ShoppingCartService.RemoveCartItems(rq);

      this.$emit("on-parts-removed", result);
    },

    cancel() {
      this.$emit("on-cancel");
    },
  },
});
